import {observable} from 'mobx';
import Structure from './Structure';
import Category from './Category';

class App {
  id = null;

  name;

  url;

  code;

  nameEn;

  nameZh;

  isShortcut;

  type = 0;

  description;

  order;

  category = new Category();

  @observable status;

  structure = new Structure();

  constructor(store, id) {
    this.id = id;
  }

  updateFromJson(json) {
    this.name = json.name;
    this.status = json.status;
    this.isShortcut = json.isShortcut;
    this.description = json.description;
    this.order = json.order;
    this.code = json.code;
    this.type = json.type || 0;
    if (json.structure) {
      this.structure.id = json.structure.id;
      this.structure.name = json.structure.name;
    } else {
      this.structure = {};
    }

    if (json.category) {
      this.category.updateFromJson(json.category);
    }
  }
}

export default App;
